import htmx from "htmx.org";
import initWidgets from "./initWidgets";

window.htmx = htmx;

htmx.on("htmx:afterSettle", function (evt) {
  initWidgets(evt.detail.elt);
});
